import { useQuery } from 'react-query'
import QueryKeys from '../utils/constants/queryKeys'
import getPairedCompetitions from '../Apis/teamPairings/getPairedCompetitions'

// The federation competitions the club team is paired into that the caller may browse.
const usePairedCompetitions = (orgId, clubTeamId, { enabled = true } = {}) =>
  useQuery(
    [QueryKeys.GET_PAIRED_COMPETITIONS, orgId, clubTeamId],
    () => getPairedCompetitions(orgId, clubTeamId),
    { enabled: Boolean(enabled && orgId && clubTeamId), staleTime: 5 * 60 * 1000, retry: false },
  )

export default usePairedCompetitions
